import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/layout'
import { LayoutBasic } from './components/layoutBasic'
import { PrivateRoute } from './utils/privateRoute'
import { AdminRoute } from './utils/adminRoute'
import { Home } from './components/home'
import Login from './components/login'
import Logout from './components/logout'
import NotFound from './components/notFound';
import { Logs } from './components/logs';
import { Management } from './components/management/management';
import { Payments } from './components/payments/payments';
import { Withdrawals } from './components/payments/withdrawals';
import { Users } from './components/users/users';
import User from './components/users/user';
import { Discounts } from './components/discounts/discounts';
import { FinishedChallenges } from './components/challenges/finishedChallenges';
import { AvailableChallenges } from './components/challenges/availableChallenges';
import { Challenge } from './components/challenges/challenge';

class App extends Component {
    render() {
        return (
            <Switch>
                <Route exact path='/login' component={HeadlessContainer} />
                <Route exact path='/logout' component={HeadlessContainer} />
                <Route component={MainContainer} />
            </Switch>
        );
    }
}

const MainContainer = () => (

    <Layout>
        <Switch>
            <AdminRoute exact path='/' component={Home} /> 
            <AdminRoute exact path='/logs' component={Logs} /> 
            <AdminRoute exact path='/management' component={Management} /> 
            <AdminRoute exact path='/payments' component={Payments} /> 
            <AdminRoute exact path='/withdrawals' component={Withdrawals} /> 
            <AdminRoute exact path='/users' component={Users} /> 
            <AdminRoute exact path='/discounts' component={Discounts} /> 
            <AdminRoute path='/users/:userId' component={User} />
            <AdminRoute exact path='/challenges' component={FinishedChallenges} /> 
            <AdminRoute exact path='/availablechallenges' component={AvailableChallenges} /> 
            <AdminRoute path='/challenge/:challengeId' component={Challenge} />
            <Route component={NotFound} />
        </Switch>
    </Layout>
)

const HeadlessContainer = () => (
    <LayoutBasic>
        <Switch>
            <Route exact path='/login' component={Login} />
            <Route exact path='/logout' component={Logout} />
        </Switch>
    </LayoutBasic>
)


export default App;